// extracted by mini-css-extract-plugin
module.exports = {"asset":"loading-step-module__asset___1udXc","removeAsset":"loading-step-module__removeAsset___3_Xoa"};